import { BillingNotificationResponseSchema } from '../../schemas.js';
/** REST contract for `insight-api/src/routes/tenant/notifications.routes.ts`. */
export const tenantNotificationsContract = {
    getSubscriptionStatus: {
        method: 'GET',
        path: '/tenant/notifications/subscription-status',
        response: BillingNotificationResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get subscription notification',
    },
};
//# sourceMappingURL=tenant-notifications.contract.js.map